export default "__VITE_ASSET__D$26rVSd__"